export function mimeTypeFromFilename(filename: string): string {
  const ext = filename.split('.').pop()?.toLowerCase() ?? '';
  const map: Record<string, string> = {
    pdf: 'application/pdf',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    webp: 'image/webp',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    txt: 'text/plain',
  };
  return map[ext] ?? 'application/octet-stream';
}

/**
 * Efetua download de um arquivo, pdf, docx etc.
 * @param blob O arquivo em formato de buffer para blob.
 * @param filename Nome do arquivo, se não informado é gerado um UUID aleatório.
 */
export function DownloadFileFromDatabaseBlob(blob: Blob | ArrayBuffer, filename?: string) {
  const name = filename?.trim() || `${generateUUID()}.pdf`;
  const typedBlob =
    blob instanceof Blob
      ? blob.type
        ? blob
        : new Blob([blob], { type: mimeTypeFromFilename(name) })
      : new Blob([blob], { type: mimeTypeFromFilename(name) });

  const url = window.URL.createObjectURL(typedBlob);

  const link = document.createElement('a');
  link.href = url;
  link.download = name;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
